/**
 * A signed-in user the backend has no organization for gets 403 with the
 * NO_ORGANIZATION reason (CB25SES-1807). The app sends them to the no-access
 * page instead of back to a login that would succeed again and loop.
 */
export const NO_ACCESS_PATH = '/no-access';
export const NO_ORGANIZATION_REASON = 'NO_ORGANIZATION';

/** True for a 403 whose error body carries the NO_ORGANIZATION reason. */
export async function isNoOrganization(response: Response): Promise<boolean> {
  if (response.status !== 403) {
    return false;
  }
  try {
    const body = await response.clone().json();
    return body?.reason === NO_ORGANIZATION_REASON;
  } catch {
    return false;
  }
}

/** True when the browser is already showing the no-access page. */
export function onNoAccessPage(): boolean {
  return (
    typeof window !== 'undefined' && window.location.pathname === NO_ACCESS_PATH
  );
}
